import { useReducer } from 'react';

import LanguageButton from './LanguageButton.jsx';
import LanguagePrompt from './LanguagePrompt.jsx';
import {
  suggestedLanguages,
  languages,
} from '../../../translations/en/supportedLanguages.json';

const closePromptReducer = () => {
  const DAYS_TO_EXPIRE_COOKIE = 365;
  window.Airbo.CookieMonster.setCookie(
    'showPrompt',
    false,
    DAYS_TO_EXPIRE_COOKIE,
  );

  return false;
};

const LanguageWrapper = ({ isRequestedLanguageDefault, browserLanguage }) => {
  const language = [...suggestedLanguages, ...languages].find(({ code }) =>
    browserLanguage.includes(code),
  ) || { name: '' };

  const isBrowserEn = language.code === 'en';

  const [showLanguagePrompt, closePrompt] = useReducer(
    closePromptReducer,
    isRequestedLanguageDefault === 'false' &&
      !isBrowserEn &&
      window.Airbo.CookieMonster.getCookie('showPrompt') !== 'false' &&
      language.name !== '',
  );

  return (
    <>
      <LanguageButton showLanguagePrompt={showLanguagePrompt} />
      {showLanguagePrompt && (
        <LanguagePrompt
          languageCode={language.code}
          closePrompt={closePrompt}
          languageName={language.name}
        />
      )}
    </>
  );
};
export default LanguageWrapper;
